export const List = () => import("./List.vue");
export const MyPreSanction = () => import("./MyPreSanction.vue");
export const Create = () => import("./Create.vue");
export const Edit = () => import("./Edit.vue");
export const View = () => import("./View.vue");
export const Copy = () => import("./Copy.vue");
